// eslint-disable-next-line no-unused-vars
import React from 'react';

const getJobLocationData = (jobData, intl) => {
  let location = null;
  let remote = '';
  if (jobData.isRemote) {
    remote = ` (${intl.formatMessage({id: 'JobDetails.Remote.Label'})})`;
  }
  const useLowerCase = process.env.REACT_APP_USE_LOWER_CASE === 'true';
  if (jobData.jobLocation && jobData.jobLocation.city && jobData.jobLocation.state) {
    if (useLowerCase) {
      location = `${jobData.jobLocation.city.toLowerCase()}, ${jobData.jobLocation.state.toLowerCase()}${remote}`;
    } else {
      location = `${jobData.jobLocation.city}, ${jobData.jobLocation.state}${remote}`;
    }
  } else if (jobData.Region) {
    location = useLowerCase ? `${jobData.Region.toLowerCase()}${remote}` : `${jobData.Region}${remote}`;
  } else if (jobData.City) {
    location = useLowerCase ? `${jobData.City.toLowerCase()}${remote}` : `${jobData.City}${remote}`;
  }

  return location;
};

export default getJobLocationData;
